import { render } from "./TestimonialDouble.vue?vue&type=template&id=560bbd40"
import script from "./TestimonialDouble.vue?vue&type=script&lang=js"
export * from "./TestimonialDouble.vue?vue&type=script&lang=js"

import "./TestimonialDouble.vue?vue&type=style&index=0&id=560bbd40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__